import React, { useMemo } from 'react';
import { Product } from './ProductGrid';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../stores/types';
import { addToCart, removeFromCart } from '../../../stores/slices/CartSlice';
import { formatXAF } from '../../../utils/currency';
import ViewModal from './ViewModal';

interface CartPanelProps {
  product: Product | null;
  products: Product[];
  open: boolean;
  onClose: () => void;
  isInCart: boolean;
  onToggleCart: (id: number) => void;
}

const CartPanel: React.FC<CartPanelProps> = ({ product, products, open, onClose, isInCart, onToggleCart }) => {
  const dispatch = useDispatch();
  const cartItems = useSelector((state: ApplicationState) => state.cart.cartItems);
  const totalPrice = useSelector((state: ApplicationState) => state.cart.totalPrice);

  const productsMap = useMemo(
    () => new Map<number, Product>(products.map((p) => [p.id, p])),
    [products]
  );

  const cartDetails = cartItems.map((item) => ({
    ...item,
    product: productsMap.get(Number(item.id)) || null,
  }));

  if (!open) return null; // Panel fermé si le bouton n'a pas été cliqué

  return (
    <div className={`cart-panel ${open ? 'open' : ''}`} id="cart-panel">
      {/* Bouton de fermeture */}
      <button className="detail-close" onClick={onClose}>×</button>

      <div id="cart-content">

        <div className="cart-section">Produits dans le panier</div>
        {cartDetails.length === 0 ? (
          <div className="empty-cart">Aucun produit dans le panier.</div>
        ) : (
          <ul className="cart-products-list">
            {cartDetails.map((item) => (
              <li key={`${item.id}`} className="cart-product-item d-flex mb-2">
                <div className="cart-product-info">
                  <span className="cart-product-name">
                    {item.product?.name ?? `Produit #${item.id}`}
                  </span>
                  <span className="cart-product-quantity">
                    {/* Quantité: {item.quantity} */}
                  </span>
                  <span className="cart-product-price"> {formatXAF(item.price)}</span>
                </div>
                <div className='d-flex justify-ccontent-end align-items-center'>
                    <button
                        type="button"
                        className="cart-product-remove"
                        onClick={() => dispatch(removeFromCart({ id: item.id, price: item.price }))}
                        >
                        Retirer
                    </button>
                </div>
              </li>
            ))}
          </ul>
        )}

        {cartDetails.length > 0 && (
          <div className="cart-summary">
            <span>{cartDetails.length} article(s) dans le panier</span>
            <strong> {formatXAF(totalPrice)}</strong>
          </div>
        )}

        {/* Liens de contact dynamiques */}
        {/* <a 
          href={`https://wa.me/237696427703?text=${encodeURIComponent('Infos sur : ' + (product ? product.name : 'mon panier'))}`}
          target="_blank"
          rel="noreferrer"
          className="contact-link whatsapp"
        >
          WhatsApp — Demander des infos
        </a> */}
      </div>
    </div>
  );
};

export default CartPanel;